import { Component, h, Prop, Element } from '@stencil/core';

/**
 * Inline label element used to annotate form fields, sections, or UI elements with short descriptive text.
 * Supports color variants for contextual styling (e.g. error, success).
 *
 * @slot default - {required}, {content}, string
 * @example
 *   <me-label>Email Address</me-label>
 */
@Component({
  tag: 'me-label',
  styleUrl: 'index.scss',
  shadow: false,
})
export class Label {
  @Element() element: HTMLElement;

  /**
   * Color variant of the label
   * @type {'primary' | 'secondary' | 'success' | 'error'}
   * @default 'primary'
   */
  @Prop() color?: 'primary' | 'secondary' | 'success' | 'error' = 'primary';

  render() {
    return (
      <div
        class={{
          label: true,
          [`label--${this.color}`]: true,
        }}
      >
        <slot></slot>
      </div>
    );
  }
}
